import styled, { keyframes } from 'styled-components';

const blink = keyframes`
  0%, 60%, 100% { opacity: 0.3; transform: scale(0.85); }
  30% { opacity: 1; transform: scale(1); }
`;

export const Bubble = styled.div`
  align-self: flex-start;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.85);
  padding: 10px 14px;
  border-radius: 16px;
  border-bottom-left-radius: 4px;
  max-width: 80%;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 5px;
  font-size: 0.92rem;
  line-height: 1.2;

  strong {
    color: rgb(255, 153, 0);
    margin-right: 6px;
  }
`;

export const Dot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgb(255, 153, 0);
  display: inline-block;
  animation: ${blink} 1.4s ease-in-out infinite;
  animation-delay: ${props => props.delay || '0s'};
`;
